class NavigationInjector {
    constructor() {
        this.navSelector = 'ul.site-nav';
        this.mobileNavSelector = 'ul.mobile-site-nav__menu';
        this.navItems = this.getNavItemsFromMetafield();
        this.maxTopicsToShow = 10; // Maximum number of topics to show
    }

    init() {
        console.log('Initializing navigation injector');
        console.log(this.navItems);
        if (this.navItems && this.navItems.TopicGroups && this.navItems.TopicGroups.length > 0) {
            this.addSloganCreatorNavItems();
        } else {
            console.warn('No navigation items found in metafield');
        }
    }

    getNavItemsFromMetafield() {
        const dataElement = document.getElementById('generated_nav');
        if (dataElement) {
            try {
                const navItems = JSON.parse(dataElement.textContent);
                console.log('Parsed navigation items:', navItems);
                return navItems;
            } catch (error) {
                console.error('Error parsing navigation items:', error);
                return null;
            }
        }
        return null;
    }

    addSloganCreatorNavItems() {
        const additionalLinksSelector = 'ul.site-nav.site-nav--center > li.site-nav__item.site-nav__more-links.more-links.site-nav__item--has-dropdown.more-links--with-dropdown > div > div > ul';

        const parentElement = document.querySelector(additionalLinksSelector);
        console.log(parentElement);

        const topicGroupsNavItem = document.createElement('li');
        topicGroupsNavItem.classList.add('site-nav__item', 'site-nav__item--has-dropdown', 'site-nav__item--smalldropdown');

        const topicGroupsNavItemLink = document.createElement('a');
        topicGroupsNavItemLink.href = '#';
        topicGroupsNavItemLink.classList.add('site-nav__link');
        topicGroupsNavItemLink.setAttribute('aria-haspopup', 'true');
        topicGroupsNavItemLink.setAttribute('aria-expanded', 'false');
        topicGroupsNavItemLink.textContent = 'Themengruppen';

        const iconSpan = document.createElement('span');
        iconSpan.classList.add('feather-icon', 'site-nav__icon');

        const iconSvg = document.createElement('svg');
        iconSvg.setAttribute('aria-hidden', 'true');
        iconSvg.setAttribute('focusable', 'false');
        iconSvg.setAttribute('role', 'presentation');
        iconSvg.classList.add('icon', 'feather-icon', 'feather-chevron-down');
        iconSvg.setAttribute('viewBox', '0 0 24 24');

        const iconPath = document.createElement('path');
        iconPath.setAttribute('d', 'M6 9l6 6 6-6');

        iconSvg.appendChild(iconPath);
        iconSpan.appendChild(iconSvg);

        topicGroupsNavItemLink.appendChild(iconSpan);

        const megaDropdownDiv = document.createElement('div');
        megaDropdownDiv.classList.add('site-nav__dropdown', 'js-mobile-menu-dropdown', 'mega-dropdown', 'container');

        const pageWidthDiv = document.createElement('div');
        pageWidthDiv.classList.add('page-width');

        const ulContainer = document.createElement('ul');
        ulContainer.classList.add('mega-dropdown__container', 'grid', 'grid--uniform');

        this.navItems.TopicGroups.forEach(group => {
            const liItem = document.createElement('li');
            liItem.classList.add('mega-dropdown__item', 'grid__item', 'one-fifth');

            const groupLink = document.createElement('a');
            groupLink.href = `/collections/${group.Handle}`;
            groupLink.classList.add('site-nav__link', 'site-nav__dropdown-heading');
            groupLink.textContent = group.Name;

            const submenuDiv = document.createElement('div');
            submenuDiv.classList.add('site-nav__submenu');

            const submenuUl = document.createElement('ul');
            submenuUl.classList.add('site-nav__submenu-container');

            group.Topics.forEach((topic, tIndex) => {
                if (tIndex >= this.maxTopicsToShow) {
                    return;
                }

                const subItem = document.createElement('li');
                subItem.classList.add('mega-dropdown__subitem');

                const subLink = document.createElement('a');
                subLink.href = `/collections/${topic.Handle}`;
                subLink.classList.add('site-nav__link', 'site-nav__dropdown-link');
                subLink.textContent = topic.Name;

                subItem.appendChild(subLink);
                submenuUl.appendChild(subItem);
            });

            submenuDiv.appendChild(submenuUl);
            liItem.appendChild(groupLink);
            liItem.appendChild(submenuDiv);
            ulContainer.appendChild(liItem);
        });

        pageWidthDiv.appendChild(ulContainer);
        megaDropdownDiv.appendChild(pageWidthDiv);
        topicGroupsNavItem.appendChild(topicGroupsNavItemLink);
        topicGroupsNavItem.appendChild(megaDropdownDiv);
        parentElement.appendChild(topicGroupsNavItem);
    }
}
